module.exports = __webpack_public_path__ + "static/img/pddshop.a24290a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pddshop.png
// module id = lEBZ
// module chunks = 13